import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	chart: {
		info: { video: 0, audio: 0, book: 0},
		totalValue: { chart1: 0, chart2: 0 },
	},
	tableData: [{}],
};


export const EducationSlice = createSlice({
	name: "education",
	initialState,
	reducers: {
		updateEduCharts: (state, action) => {
			state.chart = action.payload;
		},
	},
});

// Action creators are generated for each case reducer function
export const { updateEduCharts } = EducationSlice.actions;

export default EducationSlice.reducer;